import React, {Component} from 'react';
import {Box, Text} from 'rebass'
import {withFirebase} from '../Firebase';
import {withRouter} from 'react-router-dom';
import {compose} from 'recompose';


class SignOutButton extends Component {

	state = {
		loggedOut: false
	};
	handleSignOut = async () => {
		console.log('signout props', this.props);
		var locationEnabled = localStorage.getItem('locationEnabled')
		localStorage.clear();
		localStorage.setItem('locationEnabled',locationEnabled);
		const {firebase} = this.props;
		firebase.doSignOut().then(() => {
				console.log('signout success');
				window.location.href = '/app'
			}
		).catch((error) => console.log('error', error))


	};

	render() {


		return (
			<Box p={3} onClick={this.handleSignOut}>
				<Text ml={'6px'} fontWeight={'bold'} textAlign={this.props.textAlign}>
					Log Out
				</Text>
			</Box>
		)
	}
}


export default compose(withRouter, withFirebase)(SignOutButton);